import React from 'react'

function BidManagement() {
    return (
        <div>
            <p>Page Under Development</p>
        </div>
    )
}

export default BidManagement
